import type { GetAdditionalExpensesRequestProps } from '@services/api/otherExpenses/types'
import type { GetAdditionalExpensesFormProps } from '../context/types'

export const parseGetAdditionalExpensesPayload = (formData: GetAdditionalExpensesFormProps) => {
  const payload: GetAdditionalExpensesRequestProps = {
    routeParams: {
      filiCode: formData.filiCode!
    },
    bodyParams: {
      competenceDate: formData.competenceDate!,
      currentPage: formData.page!,
      itemsPerPage: formData.itemsPerPage!,
      sortBy: formData.sortType ? formData.sortBy! : null,
      sortType: formData.sortType || null,
      accountingCodeFilter: formData.account ? (formData.account === 'Todos' ? null : [formData.account]) : null,
      accountingDescriptionFilter: formData.accountDescription
        ? formData.accountDescription === 'Todos'
          ? null
          : [formData.accountDescription]
        : null
    }
  }

  return payload
}
